import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: 'partners/offices',
  urlRoot: 'partners/offices',

  state: {
    total: 0
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`partners/offices/${id}`, data, config)
        .then(res => {
          commit('updateSuccess', res)
          return res
        })
        .catch(err => {
          commit('updateError', err)
          return Promise.reject(err)
        })
    }
  }
})
